<template>

  <!-- card -->
  <div class="relative h-full rounded-[20px] bg-[#798B97]" id="cartLayout">

    <!-- body -->
    <div class="h-[calc(100vh-189px)] w-full pt-[8px] overflow-y-auto scrollbar">

      <template v-if="actionType === 1">

        <!-- cart button -->
        <div class="flex justify-start items-center mb-[18px] px-[22px]">
          <div class="w-[47px] relative">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="33.9" viewBox="0 0 38 33.9">
              <path id="Path_2187" data-name="Path 2187"
                    d="M10.985,53.711a1.251,1.251,0,0,1,0-2.5c4.614.016,16.784,0,21.545.008a2.768,2.768,0,0,0,2.709-2.155l2.7-11.706A2.25,2.25,0,0,0,35.759,34.6c-1.915,0-18.172-.074-26.5-.107L7.94,29.6a2.7,2.7,0,0,0-2.6-1.988H1.114a1.114,1.114,0,0,0,0,2.228H5.342a.464.464,0,0,1,.447.341l5.069,18.808a3.477,3.477,0,0,0-3.351,3.536,3.5,3.5,0,0,0,3.478,3.418h1.624a3.9,3.9,0,1,0,7.043,0h7.033A3.9,3.9,0,1,0,33.7,55.88a1.113,1.113,0,0,0-.355-2.169Zm6.817,3.9a1.671,1.671,0,1,1-1.672-1.671h0A1.673,1.673,0,0,1,17.8,57.61Zm12.406,1.67a1.671,1.671,0,0,1-.027-3.341h.054a1.671,1.671,0,0,1-.027,3.341Zm5.559-22.443a.018.018,0,0,1,0,.019l-1.139,4.933H30.775l.657-4.977,4.318.017A.018.018,0,0,1,35.767,36.837ZM24.283,48.99V44.016h3.951l-.656,4.974Zm-5.523,0L18.1,44.016h3.958V48.99Zm-5.128,0h0a.6.6,0,0,1-.581-.444l-1.221-4.53H15.85l.662,4.974Zm4.17-7.2-.67-5.035,4.924.02v5.015Zm6.482,0V36.782l4.9.02-.658,4.986Zm-9.4-5.044.671,5.044H11.226L9.861,36.724ZM32.529,48.99h-2.7l.656-4.974h3.637l-1.05,4.546A.55.55,0,0,1,32.529,48.99Z"
                    transform="translate(0 -27.609)" fill="#fff"/>
            </svg>
            <div class="absolute top-[-6px] end-[-10px] w-[34px] h-[34px] rounded-full p-1 bg-[#798B97] group-hover:bg-[#3E5463] duration-500">
              <div class="overflow-hidden w-full h-full text-white rounded-full flex justify-center items-center bg-[#FF7D97] text-[19px] font-medium">
                <span class="mt-[-4px]"> {{baskets.length}} </span>
              </div>
            </div>
          </div>
          <div class="text-[20px] sm:text-[25px] font-bold text-white ms-[27.4px] h-auto mb-0 uppercase">
            {{ lang === 'en' ? 'Basket' : 'مجموع السلة' }}
          </div>
        </div>

      </template>

      <template v-if="actionType !== 1">

        <div class="flex justify-start items-center mb-[18px] px-[22px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="24.099" height="20.667" viewBox="0 0 24.099 20.667">
            <g id="svgexport-6_27_" data-name="svgexport-6 (27)" transform="translate(0 -31.842)">
              <g id="Group_33" data-name="Group 33" transform="translate(0 31.842)">
                <g id="Group_32" data-name="Group 32" transform="translate(0 0)">
                  <path id="Path_77" data-name="Path 77"
                        d="M22.65,40.484a1.722,1.722,0,0,0-.3-.022h-17l.371-.172A3.448,3.448,0,0,0,6.7,39.6l4.768-4.768a1.785,1.785,0,0,0,.25-2.285,1.724,1.724,0,0,0-2.586-.224L.505,40.945a1.724,1.724,0,0,0,0,2.438h0l8.621,8.621a1.724,1.724,0,0,0,2.586-.172,1.785,1.785,0,0,0-.25-2.285L6.7,44.772a3.449,3.449,0,0,0-.862-.629l-.517-.233H22.257a1.785,1.785,0,0,0,1.819-1.448A1.724,1.724,0,0,0,22.65,40.484Z"
                        transform="translate(0 -31.842)" fill="#c1d5e5"/>
                </g>
              </g>
            </g>
          </svg>
          <div class="text-[20px] sm:text-[25px] font-bold text-white ms-[23.5px] uppercase">
            {{ lang === 'en' ? 'Checkout' : 'الدفع' }}
          </div>
        </div>

      </template>

      <div class="ps-[9px] pe-[11px]">

        <div
            class="w-full h-[80px] flex justify-start items-center bg-white px-[26px] rounded-[20px] mb-[13px]" v-if="userInfo">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="34.046" height="48.421" viewBox="0 0 34.046 48.421">
              <g id="svgexport-6_28_" data-name="svgexport-6 (28)" transform="translate(-76)">
                <g id="Group_35" data-name="Group 35" transform="translate(76)">
                  <g id="Group_34" data-name="Group 34">
                    <path id="Path_78" data-name="Path 78"
                          d="M93.023,0A17.026,17.026,0,0,0,78.541,25.975L92.054,47.751a1.419,1.419,0,0,0,1.205.671h.011a1.418,1.418,0,0,0,1.206-.69l13.169-21.987A17.027,17.027,0,0,0,93.023,0ZM105.21,24.288,93.238,44.278,80.953,24.48a14.2,14.2,0,1,1,24.258-.192Z"
                          transform="translate(-76)" fill="#c6a798"></path>
                  </g>
                </g>
                <g id="Group_37" data-name="Group 37" transform="translate(84.512 8.512)">
                  <g id="Group_36" data-name="Group 36">
                    <path id="Path_79" data-name="Path 79"
                          d="M174.512,90a8.512,8.512,0,1,0,8.512,8.512A8.521,8.521,0,0,0,174.512,90Zm0,14.2a5.693,5.693,0,1,1,5.684-5.693A5.7,5.7,0,0,1,174.512,104.2Z"
                          transform="translate(-166 -90)" fill="#c6a798"></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>

          <div class="ms-[18px] pe-[20px] flex-1">
            <div class="text-[17px] sm:text-[19px] font-medium text-[#35474B]">
              <div class="truncate-to-1-line" id="location_address"> {{ location?.address }}</div>
            </div>
            <div class="text-[11px] sm:text-[13px] font-light leading-[17px] text-[#35474B]">
              <div class="truncate-to-2-line" id="location_city">
                {{ location?.city }}
              </div>
            </div>
          </div>

          <div class="flex justify-center items-center flex-col -mb-[2px] w-[55px]">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-[35.269px] h-[35.34px]"
                   viewBox="0 0 35.269 33.34" v-if="deliveryStatus == 1">
                <path id="Path_2000" data-name="Path 2000"
                      d="M1.872,23.918H7.853a1.874,1.874,0,0,1,1.872,1.873v6.884h2.237a5.139,5.139,0,0,1-.14-1.605h0A15.015,15.015,0,0,1,13.235,24.5a7.047,7.047,0,0,1,2.189-2.639,4.791,4.791,0,0,1-1.282-3.393,4.384,4.384,0,1,1,8.766,0,.517.517,0,0,1-.517.517h-.351a3.637,3.637,0,0,1,.05.6A3.587,3.587,0,0,1,19.208,23.1a8.707,8.707,0,0,1,.257,2.247l1.289,1.108,3.135.254,3.617-1.2a1.1,1.1,0,0,1,1.033,0,.918.918,0,0,1,.321.771V28.97a.517.517,0,0,1-.517.517h-.615l.943,3.26a.517.517,0,0,1-.993.287l-1.027-3.547H25.184c1.827,5.571.784,9.289-.818,13.053H25.3l3.868-4.325-.818-2.826a.517.517,0,0,1,.993-.287l.782,2.7a5.2,5.2,0,0,1,5.136,4.028.517.517,0,0,1-.388.619l-.733.169A3.953,3.953,0,0,1,26.5,44.378l-.579.133a.675.675,0,0,1-.5-.028.593.593,0,0,1-.291-.4,5.139,5.139,0,0,1-.083-.514H14.238a4.4,4.4,0,0,1-8.713,0h-.49a.708.708,0,0,1-.536-.195.662.662,0,0,1-.183-.5,5.857,5.857,0,0,1,.212-1.4A8.06,8.06,0,0,1,5.1,36.266a1.36,1.36,0,0,1-.617-1.138v-1.42H1.872A1.874,1.874,0,0,1,0,31.835V25.791a1.874,1.874,0,0,1,1.872-1.873ZM28.651,45.474a2.9,2.9,0,0,0,2.2.371h0a2.927,2.927,0,0,0,2.263-2.99l-5.6,1.29a2.9,2.9,0,0,0,1.137,1.329Zm-2.585-2.057L34.1,41.568a4.161,4.161,0,0,0-4.113-2.726l-3.937,4.4Q26.057,43.331,26.065,43.417Zm-7.8-9a4.6,4.6,0,0,1,.15,1.558v1.95H20.3V35.247c0-3.024-1.65-3.563-2.391-3.652H12.847a2.19,2.19,0,0,0,.469,1.484,2.4,2.4,0,0,0,1.792.537l1.854,0A1.245,1.245,0,0,1,18.262,34.414Zm.15,4.541v1.234H22.1a1.472,1.472,0,0,0-.356-.884,1.275,1.275,0,0,0-.92-.35ZM12.87,30.562h4.7a19.29,19.29,0,0,0,.5-1.912l-1.428-.927a2.132,2.132,0,0,1-1.113-1.963,1.827,1.827,0,0,1,1.138-1.5,1.865,1.865,0,0,1,1.734.191,6.1,6.1,0,0,0-.25-1.31,3.642,3.642,0,0,1-.654-.129,4.28,4.28,0,0,1-1.206-.478C15.29,23.133,13.1,25.061,12.87,30.562Zm8.967-12.609a3.345,3.345,0,0,0-6.661.517,3.508,3.508,0,0,0,1.931,3.33V19.082a1.028,1.028,0,0,1,1.038-1.126l.047,0Zm-.78,1.629a2.573,2.573,0,0,0-.069-.6H18.217c-.032,0-.055.007-.072.011a.614.614,0,0,0-.005.085V22.1a2.557,2.557,0,0,0,.371.027h0a2.55,2.55,0,0,0,2.543-2.549Zm.67,7.985-1.224-.1a.517.517,0,0,1-.3-.123L18,25.446h0a1.026,1.026,0,0,0-.663-.278.8.8,0,0,0-.785.693,1.14,1.14,0,0,0,.647,1l2.461,1.6h2.068v-.886Zm2.183.177-1.15-.093v.8H24.1c.173,0,.215-.144.22-.265A.41.41,0,0,0,23.91,27.744Zm1.223-.357a1.492,1.492,0,0,1,.19,1.062s0,0,0,0h2.5V26.492l-2.7.891,0,0Zm-1.039,2.1H19.506a.517.517,0,0,1-.281-.083l-.234-.152c-.112.5-.241.981-.38,1.438,1.054.311,2.726,1.316,2.726,4.557v2.727a2.156,2.156,0,0,1,1.15.618,2.52,2.52,0,0,1,.646,1.6h1.042a15.194,15.194,0,0,0-.081-10.7Zm-.852,13.051c.191-.439.375-.877.548-1.316H18.426c-.7,0-1.048-.317-1.048-.941V36.489H13.3a.517.517,0,0,1,0-1.033h4.074a2.338,2.338,0,0,0-.079-.675c-.026-.069-.049-.128-.332-.128l-1.855,0a3.333,3.333,0,0,1-2.541-.859c-.025-.027-.049-.055-.073-.083H5.514v1.42a.332.332,0,0,0,.327.328h5.143a.517.517,0,1,1,0,1.033H6.145a6.1,6.1,0,0,0-.754,3.191,5.607,5.607,0,0,1,8.54-.667,5.692,5.692,0,0,1,1.624,3.526ZM9.881,46.307a3.4,3.4,0,0,0,3.307-2.734H6.575a3.4,3.4,0,0,0,3.307,2.734ZM5.988,42.539h8.529A4.634,4.634,0,0,0,9.946,38.38a4.584,4.584,0,0,0-4.4,3.285l-.006.018a4.769,4.769,0,0,0-.17.856Zm-4.955-10.7a.84.84,0,0,0,.839.84h6.82V30.007H1.033Zm0-2.862H8.691v-1.1H1.033Zm0-2.132H8.691V25.791a.84.84,0,0,0-.839-.84H1.872a.84.84,0,0,0-.839.84Z"
                      transform="translate(0 -14)" fill="#c6a798"/>
              </svg>
              <svg id="svgexport-6_9_" data-name="svgexport-6 (9)" xmlns="http://www.w3.org/2000/svg" width="35.547"
                   height="35.596" viewBox="0 0 35.547 35.596" v-if="deliveryStatus == 2">
                <g id="Group_28" data-name="Group 28" transform="translate(0 0)">
                  <path id="Path_74" data-name="Path 74"
                        d="M37.013,13.838H20.673a.551.551,0,0,0-.584.584v3.91l-1.459-.35-1.576-1.576c1.751-1.634,1.867-5.077,1.867-6.069,2.159,0,3.676-.584,4.26-1.634a2.111,2.111,0,0,0-.233-2.217,2.929,2.929,0,0,0-2.568-1.4h-2.1a4.631,4.631,0,0,0-3.618-3.91A11.368,11.368,0,0,0,13.087,1c-6.069,0-7,2.918-7,4.668V8.586A1.779,1.779,0,0,0,6.61,9.811,2.652,2.652,0,0,0,6.085,11.5,2.2,2.2,0,0,0,7.952,13.78a6.684,6.684,0,0,0,1.109,2.042L6.9,17.981c-.467.525.117,1.05.117,1.05L4.509,21.541C4.276,21.832,2,24.167,2,26.092c0,.117,0,.175.058.233l2.918,5.835c.058.175.233.233.35.292a5.767,5.767,0,0,0,1.342.175c0,.058-.058,3.326-.058,3.326a.584.584,0,1,0,1.167,0V34.32a5.506,5.506,0,0,0,4.085,2.217c1.809,0,5.135-1.167,8.053-2.217.525-.175.992-.35,1.459-.525a3.72,3.72,0,0,1,.408-.117v2.334a.584.584,0,0,0,1.167,0V33.387a10.525,10.525,0,0,1,2.918-.292h4.085c.992,0,2.334-.35,2.743-1.4a2.419,2.419,0,0,0,.175-.934h4.085a.551.551,0,0,0,.584-.584V14.421a.483.483,0,0,0-.525-.584Zm-6.419,1.167v3.151L29.076,17.4c-.058-.058-.117-.058-.233-.058s-.175,0-.233.058l-1.517.759V15.005ZM13.554,18.214a1.283,1.283,0,0,0-.35-.292,6.263,6.263,0,0,0,1.867-.292l-.233.7-.584,1.517S13.612,18.214,13.554,18.214Zm2.859-.817,1.225,1.225-.584,1.109-.992-1.342Zm1.05-11.146a7.545,7.545,0,0,0-1.342,1.4C15.13,9.111,14.254,9.17,14.254,9.17H11.162a4.407,4.407,0,0,0,.642-.817,4.455,4.455,0,0,1,3.034-2.1Zm4.493.934c.292.408.35.759.175.992-.233.467-1.225.992-3.209.992h-.058a13.954,13.954,0,0,0-.408-2.217,3.709,3.709,0,0,1,1.926-.7A1.788,1.788,0,0,1,21.957,7.186ZM7.252,5.668c0-2.1,1.692-2.976,3.618-3.326A4.919,4.919,0,0,0,9.586,5.668a.551.551,0,0,0,.584.584.585.585,0,0,0,.584-.584,3.336,3.336,0,0,1,2.976-3.443,3.513,3.513,0,0,1,3.385,2.859H14.838A5.276,5.276,0,0,0,10.87,7.652C9.878,9.111,9,9.17,9,9.17H7.835a.521.521,0,0,1-.584-.584Zm1.167,7A1.108,1.108,0,0,1,7.252,11.5c0-1.05.467-1.167.584-1.167h6.419c.175,0,1.517-.058,2.8-1.984a3.207,3.207,0,0,1,.408-.525,11.462,11.462,0,0,1,.292,2.568c0,.058.233,3.268-1.459,5.135a4.221,4.221,0,0,1-3.209,1.225A4.535,4.535,0,0,1,9,13.079.7.7,0,0,0,8.419,12.671Zm1.225,4.26,2.568,1.692-1.576,1.984-2.568-2.1ZM3.167,25.976C3.284,24.75,4.743,23,5.326,22.416l2.568-2.568,2.451,2.042a.429.429,0,0,0,.35.117h.058a.591.591,0,0,0,.408-.233l1.692-2.159.817,1.984a.561.561,0,0,0,.525.35.51.51,0,0,0,.525-.35l.759-1.926,1.109,1.517a.569.569,0,0,0,.525.233.6.6,0,0,0,.467-.292l.934-1.926,1.459.35v9.278c-.875.292-1.926.642-3.034.992-.875.292-1.751.584-2.568.875a2.255,2.255,0,0,1-2.684-.992L9.411,25.8a.591.591,0,1,0-.992.642l1.634,2.684a3.449,3.449,0,0,1-4.2,2.334Zm28.477,5.252c-.175.467-.992.7-1.634.7H25.984a13.308,13.308,0,0,0-4.9.817c-.467.175-.992.35-1.459.525-2.743.934-6.069,2.159-7.7,2.159-2.042,0-3.5-2.1-3.968-2.859a4.359,4.359,0,0,0,2.918-2.159,3.476,3.476,0,0,0,2.918,1.576,3.3,3.3,0,0,0,1.05-.175c.759-.233,1.634-.525,2.568-.875a42.926,42.926,0,0,1,6.536-1.926h4.085a.607.607,0,0,1,.584.584H27.092a.584.584,0,1,0,0,1.167s4.435.058,4.668.058A1.082,1.082,0,0,1,31.644,31.227Zm4.785-1.634H29.777a1.736,1.736,0,0,0-1.751-1.751H23.941a13.246,13.246,0,0,0-2.684.584V15.005h4.668V19.09a.7.7,0,0,0,.292.525.53.53,0,0,0,.584,0l2.1-1.05,2.1,1.05c0,.058.058.058.175.058a.437.437,0,0,0,.292-.058.613.613,0,0,0,.292-.525V15.005h4.668Z"
                        transform="translate(-2 -1)" fill="#c6a798"/>
                  <path id="Path_75" data-name="Path 75"
                        d="M40.918,43H38.584a.584.584,0,0,0,0,1.167h2.334a.584.584,0,1,0,0-1.167Z"
                        transform="translate(-16.992 -18.491)" fill="#c6a798"/>
                  <path id="Path_76" data-name="Path 76"
                        d="M38.584,41.167h1.167a.584.584,0,1,0,0-1.167H38.584a.584.584,0,0,0,0,1.167Z"
                        transform="translate(-16.992 -17.242)" fill="#c6a798"/>
                </g>
              </svg>
            </div>
            <div class="text-[14px] sm:text-[17px] font-bold text-[#C6A798] text-center">
              {{deliveryStatus == 1 ? lang === 'en' ? 'Delivery' : 'توصيل' : lang === 'en' ? 'Pickup' : 'يلتقط' }}
            </div>
          </div>

        </div>

        <div class="w-full bg-white rounded-[20px] pt-[17px] pb-[22px]">
          <template v-if="!basketLoading && baskets.length > 0">
            <template v-for="(each) in baskets" :key="each.id">
              <div class="text-[15px] sm:text-[17px] font-bold text-[#35474B] px-[22.2px] uppercase pb-[6px]">
                {{lang == 'en' ? each.title : each.title_ar}}
              </div>

              <div class="flex justify-between items-center px-[22.2px] pb-[7px]">
                <div class="flex justify-start items-center">
                  <div class="size-[27.31px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 rounded-full flex justify-center items-center cursor-pointer" @click="decreaseBasket($event, each)" v-if="!each.decreaseLoading">
                    <svg viewBox="0 0 24 24" class="w-[20px]" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path d="M6 12L18 12" stroke="#fff" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                      </g>
                    </svg>
                  </div>
                  <div class="size-[27.31px] bg-[#C6A798] rounded-full flex justify-center items-center cursor-default" v-if="each.decreaseLoading">
                     <span
                         class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                  </div>
                  <div class="text-[16px] sm:text-[19px] font-bold text-[#35474B] mx-[16.6px] -mt-[2px]">
                    {{each.quantity}}
                  </div>
                  <button class="size-[27.31px] bg-[#C6A798] hover:bg-[#B28F85] duration-500 rounded-full flex justify-center items-center cursor-pointer" @click="increaseBasket($event, each)" v-if="!each.increaseLoading">
                    <svg viewBox="0 0 24 24" class="w-[20px]" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path d="M6 12H18M12 6V18" stroke="#fff" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                      </g>
                    </svg>
                  </button>
                  <div class="size-[27.31px] bg-[#C6A798] rounded-full flex justify-center items-center cursor-default" v-if="each.increaseLoading">
                     <span
                         class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                  </div>
                </div>
                <div class="font-bold text-[16px] sm:text-[18]">
                  {{ each.total_price }} <span
                    class="uppercase ms-1 text-[13px]"> {{ lang === 'en' ? 'Sar' : '﷼' }} </span>
                </div>
              </div>

              <div class="px-[22.2px] mb-[7.2px]">
                <div class="border-b-2 border-gray-300"></div>
              </div>
            </template>
          </template>
          <template v-if="!basketLoading && baskets.length === 0">
            <div class="h-[120px] flex items-center justify-center">No baskets found.</div>
          </template>
          <template v-if="basketLoading">
            <div class="h-[120px] flex items-center justify-center">
              <LoaderVue/>
            </div>
          </template>
        </div>

        <!-- Offers -->
        <template v-if="actionType === 4">
          <CartOffer @handleDiscount="handleDiscount" />
        </template>
        <template v-if="actionType == 4">
          <PaymentSummary :basketTotal="basketTotal" :deliveryPrice="deliveryPrice" :discount="discount" />
        </template>

        <!-- Pay with -->
        <template v-if="actionType === 4">
          <div class="w-full bg-white rounded-[20px] px-[17px] pt-[10px] mt-[15px] pb-[20px] mb-[15px]">
            <div class="text-[20px] sm:text-[25px] font-bold text-[#35474B] uppercase mb-[11px]">
              {{ lang === 'en' ? 'Pay With' : 'ادفع باستخدام' }}
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              <a href="javascript:void(0)"
                 class="w-full h-[91px] border border-[#C1DBEC] rounded-[5px_17px_5px_5px] bg-[#35474B] uppercase shadow-[0_3px_6px_0_#E0E9F0] relative">
                <div class="absolute top-[-0.5px] end-[-0.5px]">
                  <svg id="svgexport-6_29_" data-name="svgexport-6 (29)" xmlns="http://www.w3.org/2000/svg"
                       width="29.982" height="30.119" viewBox="0 0 29.982 30.119">
                    <g id="Checkmark" transform="translate(0 0)">
                      <path id="Path_90" data-name="Path 90"
                            d="M22.991,8A15.06,15.06,0,1,0,37.982,23.059,15.025,15.025,0,0,0,22.991,8Zm8.376,10.924L22,28.337a1.233,1.233,0,0,1-1.761,0l-4.372-4.392a1.255,1.255,0,0,1,0-1.769,1.242,1.242,0,0,1,1.761,0l3.492,3.5,8.489-8.521a1.242,1.242,0,0,1,1.761,0,1.255,1.255,0,0,1,0,1.769Z"
                            transform="translate(-8 -8)" fill="#c6a798"/>
                      <path id="Path_91" data-name="Path 91"
                            d="M35.8,24.123l-9.327,9.327a1.231,1.231,0,0,1-1.753,0L20.369,29.1a1.24,1.24,0,0,1,1.753-1.753l3.476,3.47,8.45-8.444A1.24,1.24,0,1,1,35.8,24.123Z"
                            transform="translate(-12.466 -13.165)" fill="#fff"/>
                    </g>
                  </svg>
                </div>
                <div class="pt-[12.5px] ps-[10.7px]">
                  <svg id="Group_88" data-name="Group 88" xmlns="http://www.w3.org/2000/svg" width="49.191"
                       height="16.403" viewBox="0 0 49.191 16.403">
                    <rect id="Rectangle_59" data-name="Rectangle 59" width="20.808" height="6.932"
                          transform="translate(0 9.459)" fill="#84b740"/>
                    <rect id="Rectangle_60" data-name="Rectangle 60" width="20.808" height="6.938"
                          transform="translate(0 0)" fill="#259bd6"/>
                    <path id="Path_80" data-name="Path 80"
                          d="M723.565,507.284l-.093.019a3.037,3.037,0,0,1-.673.086c-.544,0-1.186-.278-1.186-1.588,0-.673.111-1.569,1.124-1.569h.006a3.046,3.046,0,0,1,.741.142l.08.025Zm.167-6.53-.167.031v2.422l-.148-.043-.043-.012a3.406,3.406,0,0,0-.921-.161c-2.027,0-2.453,1.532-2.453,2.817a2.5,2.5,0,0,0,2.712,2.774,5.5,5.5,0,0,0,1.81-.253.8.8,0,0,0,.68-.877V500.5c-.482.086-.982.173-1.47.253"
                          transform="translate(-681.948 -492.302)" fill="#eef8fd"/>
                    <path id="Path_81" data-name="Path 81"
                          d="M822.191,544.668l-.087.025-.309.08a3.219,3.219,0,0,1-.748.117c-.476,0-.76-.235-.76-.636,0-.259.117-.7.9-.7h1.007Zm-.71-4.368a6.839,6.839,0,0,0-2.064.358l-.519.154.173,1.174.507-.167a5.955,5.955,0,0,1,1.687-.284c.223,0,.9,0,.9.735v.321h-.945c-1.724,0-2.521.55-2.521,1.73,0,1.007.735,1.613,1.971,1.613a6.371,6.371,0,0,0,1.371-.185l.025-.006.025.006.154.025c.482.086.982.173,1.47.266v-3.855c0-1.248-.754-1.884-2.237-1.884"
                          transform="translate(-774.551 -529.643)" fill="#eef8fd"/>
                    <path id="Path_82" data-name="Path 82"
                          d="M627.891,544.668l-.087.025-.309.08a3.171,3.171,0,0,1-.748.117c-.476,0-.76-.235-.76-.636,0-.259.117-.7.89-.7h1.007v1.112Zm-.7-4.368a6.809,6.809,0,0,0-2.064.358l-.519.154.173,1.174.507-.167a5.956,5.956,0,0,1,1.687-.284c.222,0,.9,0,.9.735v.321h-.945c-1.724,0-2.527.55-2.527,1.73,0,1.007.735,1.613,1.977,1.613a6.372,6.372,0,0,0,1.372-.185l.025-.006.025.006.148.025c.488.086.982.173,1.47.272V542.19c.006-1.26-.747-1.891-2.23-1.891"
                          transform="translate(-592.255 -529.643)" fill="#eef8fd"/>
                    <path id="Path_83" data-name="Path 83"
                          d="M487.6,540.406a4.169,4.169,0,0,0-1.674.371l-.062.031-.056-.043a2.534,2.534,0,0,0-1.5-.365,6.141,6.141,0,0,0-1.773.266c-.525.161-.729.414-.729.89v4.405h1.643v-4.072l.08-.025a2.091,2.091,0,0,1,.723-.13.65.65,0,0,1,.717.748v3.484h1.619v-3.552a1.193,1.193,0,0,0-.049-.358l-.056-.105.111-.049a1.948,1.948,0,0,1,.8-.167.655.655,0,0,1,.717.748v3.484h1.612v-3.645c0-1.291-.692-1.915-2.125-1.915"
                          transform="translate(-458.465 -529.736)" fill="#eef8fd"/>
                    <path id="Path_84" data-name="Path 84"
                          d="M695.54,372.322a5.6,5.6,0,0,1-.958-.087l-.093-.018v-2.379a1.158,1.158,0,0,0-.043-.34l-.049-.1.1-.043c.025-.012.049-.019.08-.031l.019-.012.111-.037a.157.157,0,0,1,.043-.012,3.836,3.836,0,0,1,.846-.1h.006c1.007,0,1.124.9,1.124,1.569-.006,1.31-.655,1.588-1.193,1.588m-.006-4.522h-.043a2.911,2.911,0,0,0-2.261.766,1.546,1.546,0,0,0-.3.921h0v2.453a.723.723,0,0,1-.049.309l-.056.105h-2.984v-1.705h-.006a2.542,2.542,0,0,0-2.638-2.786h-1.5c-.062.439-.111.748-.173,1.186h1.5c.785,0,1.2.667,1.2,1.693v1.718l-.105-.056a1.133,1.133,0,0,0-.352-.049h-2.582c-.049.327-.111.754-.179,1.18h7.939c.272-.056.587-.105.859-.148a4.471,4.471,0,0,0,1.662.3,2.948,2.948,0,0,0,.074-5.888"
                          transform="translate(-649.111 -367.8)" fill="#eef8fd"/>
                    <path id="Path_85" data-name="Path 85"
                          d="M490.968,375.288h.074c1.724,0,2.527-.568,2.527-1.971a1.8,1.8,0,0,0-1.971-1.81h-1.588a.684.684,0,0,1-.76-.729c0-.309.117-.692.9-.692h3.472c.074-.451.111-.735.179-1.186H490.19c-1.68,0-2.527.7-2.527,1.878s.735,1.767,1.971,1.767h1.588a.75.75,0,0,1,.76.772.776.776,0,0,1-.89.8h-.266l-5.085-.012h-.927c-.785,0-1.335-.445-1.335-1.477v-.71c0-1.075.426-1.742,1.335-1.742h1.507c.068-.457.111-.748.173-1.18h-2.057a2.578,2.578,0,0,0-2.638,2.83h0v.8a2.438,2.438,0,0,0,2.638,2.657h1.5l2.755.006h2.274Z"
                          transform="translate(-458.465 -368.832)" fill="#eef8fd"/>
                  </svg>
                </div>
                <div class="pt-[9.5px] ps-[9px] text-[24px] font-bold text-white">
                  {{ lang === 'en' ? 'CASH' : 'CASH' }}
                </div>
              </a>
              <a href="javascript:void(0)"
                 class="w-full h-[91px] border border-[#C1DBEC] rounded-[5px_17px_5px_5px] bg-[#E0E9F0] uppercase shadow-[0_3px_6px_0_#E0E9F0] relative  cursor-default">
                <div class="pt-[12.5px] ps-[10.7px]">
                  <svg id="Group_88" data-name="Group 88" xmlns="http://www.w3.org/2000/svg" width="49.191"
                       height="16.403" viewBox="0 0 49.191 16.403">
                    <rect id="Rectangle_59" data-name="Rectangle 59" width="20.808" height="6.932"
                          transform="translate(0 9.459)" fill="#84b740"/>
                    <rect id="Rectangle_60" data-name="Rectangle 60" width="20.808" height="6.938"
                          transform="translate(0 0)" fill="#259bd6"/>
                    <path id="Path_80" data-name="Path 80"
                          d="M723.565,507.284l-.093.019a3.037,3.037,0,0,1-.673.086c-.544,0-1.186-.278-1.186-1.588,0-.673.111-1.569,1.124-1.569h.006a3.046,3.046,0,0,1,.741.142l.08.025Zm.167-6.53-.167.031v2.422l-.148-.043-.043-.012a3.406,3.406,0,0,0-.921-.161c-2.027,0-2.453,1.532-2.453,2.817a2.5,2.5,0,0,0,2.712,2.774,5.5,5.5,0,0,0,1.81-.253.8.8,0,0,0,.68-.877V500.5c-.482.086-.982.173-1.47.253"
                          transform="translate(-681.948 -492.302)" fill="#eef8fd"/>
                    <path id="Path_81" data-name="Path 81"
                          d="M822.191,544.668l-.087.025-.309.08a3.219,3.219,0,0,1-.748.117c-.476,0-.76-.235-.76-.636,0-.259.117-.7.9-.7h1.007Zm-.71-4.368a6.839,6.839,0,0,0-2.064.358l-.519.154.173,1.174.507-.167a5.955,5.955,0,0,1,1.687-.284c.223,0,.9,0,.9.735v.321h-.945c-1.724,0-2.521.55-2.521,1.73,0,1.007.735,1.613,1.971,1.613a6.371,6.371,0,0,0,1.371-.185l.025-.006.025.006.154.025c.482.086.982.173,1.47.266v-3.855c0-1.248-.754-1.884-2.237-1.884"
                          transform="translate(-774.551 -529.643)" fill="#eef8fd"/>
                    <path id="Path_82" data-name="Path 82"
                          d="M627.891,544.668l-.087.025-.309.08a3.171,3.171,0,0,1-.748.117c-.476,0-.76-.235-.76-.636,0-.259.117-.7.89-.7h1.007v1.112Zm-.7-4.368a6.809,6.809,0,0,0-2.064.358l-.519.154.173,1.174.507-.167a5.956,5.956,0,0,1,1.687-.284c.222,0,.9,0,.9.735v.321h-.945c-1.724,0-2.527.55-2.527,1.73,0,1.007.735,1.613,1.977,1.613a6.372,6.372,0,0,0,1.372-.185l.025-.006.025.006.148.025c.488.086.982.173,1.47.272V542.19c.006-1.26-.747-1.891-2.23-1.891"
                          transform="translate(-592.255 -529.643)" fill="#eef8fd"/>
                    <path id="Path_83" data-name="Path 83"
                          d="M487.6,540.406a4.169,4.169,0,0,0-1.674.371l-.062.031-.056-.043a2.534,2.534,0,0,0-1.5-.365,6.141,6.141,0,0,0-1.773.266c-.525.161-.729.414-.729.89v4.405h1.643v-4.072l.08-.025a2.091,2.091,0,0,1,.723-.13.65.65,0,0,1,.717.748v3.484h1.619v-3.552a1.193,1.193,0,0,0-.049-.358l-.056-.105.111-.049a1.948,1.948,0,0,1,.8-.167.655.655,0,0,1,.717.748v3.484h1.612v-3.645c0-1.291-.692-1.915-2.125-1.915"
                          transform="translate(-458.465 -529.736)" fill="#eef8fd"/>
                    <path id="Path_84" data-name="Path 84"
                          d="M695.54,372.322a5.6,5.6,0,0,1-.958-.087l-.093-.018v-2.379a1.158,1.158,0,0,0-.043-.34l-.049-.1.1-.043c.025-.012.049-.019.08-.031l.019-.012.111-.037a.157.157,0,0,1,.043-.012,3.836,3.836,0,0,1,.846-.1h.006c1.007,0,1.124.9,1.124,1.569-.006,1.31-.655,1.588-1.193,1.588m-.006-4.522h-.043a2.911,2.911,0,0,0-2.261.766,1.546,1.546,0,0,0-.3.921h0v2.453a.723.723,0,0,1-.049.309l-.056.105h-2.984v-1.705h-.006a2.542,2.542,0,0,0-2.638-2.786h-1.5c-.062.439-.111.748-.173,1.186h1.5c.785,0,1.2.667,1.2,1.693v1.718l-.105-.056a1.133,1.133,0,0,0-.352-.049h-2.582c-.049.327-.111.754-.179,1.18h7.939c.272-.056.587-.105.859-.148a4.471,4.471,0,0,0,1.662.3,2.948,2.948,0,0,0,.074-5.888"
                          transform="translate(-649.111 -367.8)" fill="#eef8fd"/>
                    <path id="Path_85" data-name="Path 85"
                          d="M490.968,375.288h.074c1.724,0,2.527-.568,2.527-1.971a1.8,1.8,0,0,0-1.971-1.81h-1.588a.684.684,0,0,1-.76-.729c0-.309.117-.692.9-.692h3.472c.074-.451.111-.735.179-1.186H490.19c-1.68,0-2.527.7-2.527,1.878s.735,1.767,1.971,1.767h1.588a.75.75,0,0,1,.76.772.776.776,0,0,1-.89.8h-.266l-5.085-.012h-.927c-.785,0-1.335-.445-1.335-1.477v-.71c0-1.075.426-1.742,1.335-1.742h1.507c.068-.457.111-.748.173-1.18h-2.057a2.578,2.578,0,0,0-2.638,2.83h0v.8a2.438,2.438,0,0,0,2.638,2.657h1.5l2.755.006h2.274Z"
                          transform="translate(-458.465 -368.832)" fill="#eef8fd"/>
                  </svg>
                </div>
                <div class="pt-[9.5px] ps-[9px] text-[24px] font-bold text-[#35474B] opacity-20">
                  {{ lang === 'en' ? 'CREDIT' : 'CREDIT' }}
                </div>
              </a>

              <a href="javascript:void(0)"
                 class="w-full h-[91px] border border-[#C1DBEC] rounded-[5px_17px_5px_5px] bg-[#E0E9F0] uppercase shadow-[0_3px_6px_0_#E0E9F0] relative  cursor-default">
                <div class="pt-[12.5px] ps-[10.7px]">
                  <svg id="Group_88" data-name="Group 88" xmlns="http://www.w3.org/2000/svg" width="49.191"
                       height="16.403" viewBox="0 0 49.191 16.403">
                    <rect id="Rectangle_59" data-name="Rectangle 59" width="20.808" height="6.932"
                          transform="translate(0 9.459)" fill="#84b740"/>
                    <rect id="Rectangle_60" data-name="Rectangle 60" width="20.808" height="6.938"
                          transform="translate(0 0)" fill="#259bd6"/>
                    <path id="Path_80" data-name="Path 80"
                          d="M723.565,507.284l-.093.019a3.037,3.037,0,0,1-.673.086c-.544,0-1.186-.278-1.186-1.588,0-.673.111-1.569,1.124-1.569h.006a3.046,3.046,0,0,1,.741.142l.08.025Zm.167-6.53-.167.031v2.422l-.148-.043-.043-.012a3.406,3.406,0,0,0-.921-.161c-2.027,0-2.453,1.532-2.453,2.817a2.5,2.5,0,0,0,2.712,2.774,5.5,5.5,0,0,0,1.81-.253.8.8,0,0,0,.68-.877V500.5c-.482.086-.982.173-1.47.253"
                          transform="translate(-681.948 -492.302)" fill="#eef8fd"/>
                    <path id="Path_81" data-name="Path 81"
                          d="M822.191,544.668l-.087.025-.309.08a3.219,3.219,0,0,1-.748.117c-.476,0-.76-.235-.76-.636,0-.259.117-.7.9-.7h1.007Zm-.71-4.368a6.839,6.839,0,0,0-2.064.358l-.519.154.173,1.174.507-.167a5.955,5.955,0,0,1,1.687-.284c.223,0,.9,0,.9.735v.321h-.945c-1.724,0-2.521.55-2.521,1.73,0,1.007.735,1.613,1.971,1.613a6.371,6.371,0,0,0,1.371-.185l.025-.006.025.006.154.025c.482.086.982.173,1.47.266v-3.855c0-1.248-.754-1.884-2.237-1.884"
                          transform="translate(-774.551 -529.643)" fill="#eef8fd"/>
                    <path id="Path_82" data-name="Path 82"
                          d="M627.891,544.668l-.087.025-.309.08a3.171,3.171,0,0,1-.748.117c-.476,0-.76-.235-.76-.636,0-.259.117-.7.89-.7h1.007v1.112Zm-.7-4.368a6.809,6.809,0,0,0-2.064.358l-.519.154.173,1.174.507-.167a5.956,5.956,0,0,1,1.687-.284c.222,0,.9,0,.9.735v.321h-.945c-1.724,0-2.527.55-2.527,1.73,0,1.007.735,1.613,1.977,1.613a6.372,6.372,0,0,0,1.372-.185l.025-.006.025.006.148.025c.488.086.982.173,1.47.272V542.19c.006-1.26-.747-1.891-2.23-1.891"
                          transform="translate(-592.255 -529.643)" fill="#eef8fd"/>
                    <path id="Path_83" data-name="Path 83"
                          d="M487.6,540.406a4.169,4.169,0,0,0-1.674.371l-.062.031-.056-.043a2.534,2.534,0,0,0-1.5-.365,6.141,6.141,0,0,0-1.773.266c-.525.161-.729.414-.729.89v4.405h1.643v-4.072l.08-.025a2.091,2.091,0,0,1,.723-.13.65.65,0,0,1,.717.748v3.484h1.619v-3.552a1.193,1.193,0,0,0-.049-.358l-.056-.105.111-.049a1.948,1.948,0,0,1,.8-.167.655.655,0,0,1,.717.748v3.484h1.612v-3.645c0-1.291-.692-1.915-2.125-1.915"
                          transform="translate(-458.465 -529.736)" fill="#eef8fd"/>
                    <path id="Path_84" data-name="Path 84"
                          d="M695.54,372.322a5.6,5.6,0,0,1-.958-.087l-.093-.018v-2.379a1.158,1.158,0,0,0-.043-.34l-.049-.1.1-.043c.025-.012.049-.019.08-.031l.019-.012.111-.037a.157.157,0,0,1,.043-.012,3.836,3.836,0,0,1,.846-.1h.006c1.007,0,1.124.9,1.124,1.569-.006,1.31-.655,1.588-1.193,1.588m-.006-4.522h-.043a2.911,2.911,0,0,0-2.261.766,1.546,1.546,0,0,0-.3.921h0v2.453a.723.723,0,0,1-.049.309l-.056.105h-2.984v-1.705h-.006a2.542,2.542,0,0,0-2.638-2.786h-1.5c-.062.439-.111.748-.173,1.186h1.5c.785,0,1.2.667,1.2,1.693v1.718l-.105-.056a1.133,1.133,0,0,0-.352-.049h-2.582c-.049.327-.111.754-.179,1.18h7.939c.272-.056.587-.105.859-.148a4.471,4.471,0,0,0,1.662.3,2.948,2.948,0,0,0,.074-5.888"
                          transform="translate(-649.111 -367.8)" fill="#eef8fd"/>
                    <path id="Path_85" data-name="Path 85"
                          d="M490.968,375.288h.074c1.724,0,2.527-.568,2.527-1.971a1.8,1.8,0,0,0-1.971-1.81h-1.588a.684.684,0,0,1-.76-.729c0-.309.117-.692.9-.692h3.472c.074-.451.111-.735.179-1.186H490.19c-1.68,0-2.527.7-2.527,1.878s.735,1.767,1.971,1.767h1.588a.75.75,0,0,1,.76.772.776.776,0,0,1-.89.8h-.266l-5.085-.012h-.927c-.785,0-1.335-.445-1.335-1.477v-.71c0-1.075.426-1.742,1.335-1.742h1.507c.068-.457.111-.748.173-1.18h-2.057a2.578,2.578,0,0,0-2.638,2.83h0v.8a2.438,2.438,0,0,0,2.638,2.657h1.5l2.755.006h2.274Z"
                          transform="translate(-458.465 -368.832)" fill="#eef8fd"/>
                  </svg>
                </div>
                <div class="pt-[9.5px] ps-[9px] text-[16px] font-bold text-[#35474B] opacity-20">
                  {{ lang === 'en' ? 'Ending' : 'إنهاء' }}
                </div>
                <div class="ps-[9px] text-[24px] -mt-[7px] text-[#35474B] opacity-20">
                  3545
                </div>
              </a>

              <a href="javascript:void(0)"
                 class="w-full h-[91px] border border-[#C1DBEC] rounded-[5px_17px_5px_5px] bg-[#E0E9F0] uppercase shadow-[0_3px_6px_0_#E0E9F0] cursor-default">
                <div class="pt-[8.5px] ps-[10.7px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="35.954" height="27.899" viewBox="0 0 35.954 27.899">
                    <g id="Group_86" data-name="Group 86" opacity="0.35">
                      <path id="Path_92" data-name="Path 92"
                            d="M17.674,172.73v-1.852a1.086,1.086,0,0,0-1.173-1.173,1.217,1.217,0,0,0-1.049.525,1.08,1.08,0,0,0-.988-.525,1,1,0,0,0-.864.432v-.37h-.648v2.963H13.6v-1.636c0-.525.278-.772.71-.772s.648.278.648.772v1.636h.648v-1.636a.683.683,0,0,1,.71-.772c.432,0,.648.278.648.772v1.636Zm9.6-2.963H26.223v-.895h-.648v.895h-.586v.586h.586v1.358c0,.679.278,1.08,1.018,1.08a1.727,1.727,0,0,0,.8-.216l-.185-.556a1.016,1.016,0,0,1-.555.154c-.309,0-.432-.185-.432-.494v-1.327h1.049v-.586Zm5.493-.062a.87.87,0,0,0-.772.432v-.37h-.648v2.963h.648v-1.666c0-.494.216-.772.617-.772a1.8,1.8,0,0,1,.4.062l.185-.617a2.038,2.038,0,0,0-.432-.031Zm-8.3.309a2.118,2.118,0,0,0-1.2-.309c-.741,0-1.234.37-1.234.957,0,.494.37.772,1.018.864l.309.031c.339.062.525.154.525.309,0,.216-.247.37-.679.37a1.7,1.7,0,0,1-.988-.309l-.309.494a2.183,2.183,0,0,0,1.265.37c.864,0,1.358-.4,1.358-.957,0-.525-.4-.8-1.018-.895l-.309-.031c-.278-.031-.494-.093-.494-.278,0-.216.216-.34.556-.34a2.224,2.224,0,0,1,.926.247l.278-.525Zm17.221-.309a.87.87,0,0,0-.772.432v-.37h-.648v2.963h.648v-1.666c0-.494.216-.772.617-.772a1.8,1.8,0,0,1,.4.062l.185-.617a2.038,2.038,0,0,0-.432-.031Zm-8.271,1.543a1.482,1.482,0,0,0,1.574,1.543,1.535,1.535,0,0,0,1.049-.339l-.309-.525a1.247,1.247,0,0,1-.772.278.876.876,0,0,1-.895-.957.91.91,0,0,1,.895-.957,1.246,1.246,0,0,1,.772.278l.309-.525a1.535,1.535,0,0,0-1.049-.34,1.482,1.482,0,0,0-1.574,1.543Zm5.987,0v-1.481h-.648v.37a1.115,1.115,0,0,0-.926-.432,1.544,1.544,0,0,0,0,3.086,1.039,1.039,0,0,0,.926-.432v.37H39.4Zm-2.376,0a.9.9,0,1,1,1.79,0,.9.9,0,1,1-1.79,0Zm-7.746-1.543a1.544,1.544,0,0,0,.031,3.086,1.889,1.889,0,0,0,1.2-.4l-.309-.463a1.475,1.475,0,0,1-.864.309.833.833,0,0,1-.9-.71h2.191v-.247a1.364,1.364,0,0,0-1.358-1.574Zm0,.555a.722.722,0,0,1,.741.71H28.476a.782.782,0,0,1,.8-.71Zm16.079.988V168.6h-.648v1.543a1.115,1.115,0,0,0-.926-.432,1.544,1.544,0,0,0,0,3.086,1.039,1.039,0,0,0,.926-.432v.37h.648Zm-2.376,0a.9.9,0,1,1,1.79,0,.9.9,0,1,1-1.79,0Zm-21.665,0v-1.481h-.648v.37a1.115,1.115,0,0,0-.926-.432,1.544,1.544,0,0,0,0,3.086,1.039,1.039,0,0,0,.926-.432v.37h.648Zm-2.407,0a.9.9,0,1,1,1.79,0,.9.9,0,1,1-1.79,0Z"
                            transform="translate(-11.131 -144.893)"/>
                      <rect id="Rectangle_72" data-name="Rectangle 72" width="9.721" height="17.468"
                            transform="translate(13.116 2.376)" fill="#ff5f00"/>
                      <path id="Path_93" data-name="Path 93"
                            d="M13.734,11.11a11.14,11.14,0,0,1,4.228-8.734A11.106,11.106,0,1,0,11.11,22.221a11.041,11.041,0,0,0,6.851-2.376A11.094,11.094,0,0,1,13.734,11.11Z"
                            transform="translate(0 0)" fill="#eb001b"/>
                      <path id="Path_94" data-name="Path 94"
                            d="M145.945,11.11a11.1,11.1,0,0,1-17.962,8.734,11.135,11.135,0,0,0,0-17.468,11.1,11.1,0,0,1,17.962,8.734Z"
                            transform="translate(-109.991 0)" fill="#f79e1b"/>
                    </g>
                  </svg>
                </div>
                <div class="pt-[2px] ps-[9px] text-[16px] font-bold text-[#35474B] opacity-20">
                  {{ lang === 'en' ? 'Ending' : 'إنهاء' }}
                </div>
                <div class="ps-[9px] text-[24px] -mt-[7px] text-[#35474B] opacity-20">
                  3545
                </div>
              </a>

              <button
                 class="w-full h-[91px] border border-[#C1DBEC] rounded-[5px_17px_5px_5px] bg-[#E0E9F0] uppercase shadow-[0_3px_6px_0_#E0E9F0]"
                 :disabled="true"
                 @click="handleActionType($event, 5)">
                <div class="flex justify-end mb-[5px]">
                  <div
                      class="size-[32.69px] relative -top-[1px] -end-[1px] flex justify-center items-center bg-[#35474B] rounded-full cursor-pointer">
                    <svg viewBox="0 0 24 24" class="size-[25px]" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round"
                         stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path d="M6 12H18M12 6V18" stroke="#fff" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div class="ps-[15px] pb-[6px] text-[#35474B]">
                  <div class="text-[15px] font-bold"> {{ lang === 'en' ? 'Add new' : 'أضف جديدا' }}</div>
                  <div class="text-[20px] font-bold -mt-[7px]"> {{ lang === 'en' ? 'card' : 'بطاقة' }}</div>
                </div>
              </button>
            </div>

          </div>
        </template>

      </div>
    </div>

    <template v-if="actionType === 1">
      <div class="bg-white h-auto w-full pt-[16px] ps-[21px] pe-[21px] pb-[19px] rounded-b-[20px]">
        <a href="javascript:void(0)"
           class="border-0 outline-0 bg-[#C6A798] hover:bg-[#B28F85] duration-500 rounded-[12px] px-[43px] h-[64px] w-full flex justify-center gap-x-[14px] items-center uppercase text-white text-[18px] sm:text-[21px] font-bold"
           @click="handleActionType($event, 2)">
          {{ lang === 'en' ? 'Login' : 'تسجيل الدخول' }}
        </a>
      </div>
    </template>

    <template v-if="actionType === 2">
      <!-- login form -->
      <CartLoginForm @handleLogin="handleLogin"/>
    </template>

    <template v-if="actionType === 3">
      <CartVerification @handleVerify="handleVerify" :phone="phone"/>
    </template>

    <!-- continue button -->
    <template v-if="actionType === 4">
      <div class="bg-[#E0E9F0] h-auto w-full pt-[16px] ps-[21px] pe-[21px] pb-[19px] rounded-b-[18.5px]">
        <button
           class="border-0 outline-0 bg-[#C6A798] text-opacity-35 hover:bg-[#B28F85] duration-500 rounded-[12px] px-[43px] h-[64px] w-full flex justify-center gap-x-[14px] items-center uppercase text-white text-[18px] sm:text-[21px] font-bold"
           :disabled="baskets.length == 0"
            @click="handleOrderComplete($event)" v-if="!checkoutLoading">
          {{ lang === 'en' ? 'Continue' : 'يكمل' }}
        </button>
        <a href="javascript:void(0)"
           class="border-0 outline-0 bg-[#C6A798] text-opacity-35 hover:bg-[#B28F85] duration-500 rounded-[12px] px-[43px] h-[64px] w-full flex justify-center gap-x-[14px] items-center uppercase text-white text-[18px] sm:text-[21px] font-bold"
            v-if="checkoutLoading">
          <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
        </a>
      </div>
    </template>

    <!-- payment card form information -->
    <template v-if="actionType === 5">
      <AddCard @handleOrderComplete="handleOrderComplete"/>
    </template>


    <div class="fixed w-full h-full inset-0 z-50 flex justify-center items-center bg-black/45 duration-500"
         v-if="removeBasketModal" :class="{ 'visible' : removeBasketModal, 'invisible' : !removeBasketModal }">
      <div class="w-full max-w-[575px] duration-500"
           :class="{'opacity-100 scale-100': removeBasketModal, 'opacity-0 scale-50' : !removeBasketModal}">
        <div class="p-5 lg:p-[33px] bg-[transparent]">
          <div class="bg-white p-6 lg:pt-[37px] lg:pb-[14px] rounded-[20px] w-full relative">
            <div class="absolute top-[-15px] end-[-15px] z-[99999999]">
              <button type="button"
                      class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]"
                      @click="closeModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
                  <path id="Path_2192" data-name="Path 2192"
                        d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0"
                        transform="translate(0 -0.136)" fill="#3e5463"/>
                </svg>
              </button>
            </div>
            <form class="p-4" @submit.prevent="removeBasketItem">
              <div class="h-[250px] flex items-center justify-center">
                <div class="mb-[40px]">
                  <div class="text-center mb-3">
                    <svg viewBox="0 0 24 24" class="size-[75px] mx-auto" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path class="stroke-[#E1523D]"
                              d="M9.1709 4C9.58273 2.83481 10.694 2 12.0002 2C13.3064 2 14.4177 2.83481 14.8295 4"
                              stroke-width="1.5" stroke-linecap="round"></path>
                        <path class="stroke-[#E1523D]" d="M20.5001 6H3.5" stroke-width="1.5"
                              stroke-linecap="round"></path>
                        <path class="stroke-[#E1523D]"
                              d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                              stroke-width="1.5" stroke-linecap="round"></path>
                        <path class="stroke-[#E1523D]" d="M9.5 11L10 16" stroke-width="1.5"
                              stroke-linecap="round"></path>
                        <path class="stroke-[#E1523D]" d="M14.5 11L14 16" stroke-width="1.5"
                              stroke-linecap="round"></path>
                      </g>
                    </svg>
                  </div>
                  <div class="text-center text-2xl">{{lang == 'en' ? 'Are you sure?' : 'هل أنت متأكد؟'}}</div>
                  <div class="text-center text-lg">{{lang == 'en' ? 'You want to remove this basket.' : 'هلتريد إزالة هذه السلة.'}}</div>
                </div>
              </div>

              <div class="flex items-center justify-end">
                <button type="submit" class="h-[45px] bg-[#3E5463] hover:bg-[#33464A] duration-500 text-white rounded-[10px] flex justify-center items-center w-[120px] me-3"
                        v-if="!removeBasketLoading">
                  {{ lang == 'en' ? 'yes' : 'نعم' }}</button>
                <button type="submit" class="h-[45px] bg-[#3E5463] text-white rounded-[10px] flex justify-center items-center w-[120px] me-3"
                        :disabled="true" v-if="removeBasketLoading">
                         <span class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                </button>
                <button type="button" class="h-[45px] bg-[#B21221] hover:bg-[#9B101E] duration-500 text-white rounded-[10px] flex justify-center items-center w-[120px]" @click="closeModal">
                  {{ lang == 'en' ? 'Cancel' : 'يلغي'}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import CartOffer from "./cardLayoutWidgets/CartOffer.vue";
import PaymentSummary from "./cardLayoutWidgets/PaymentSummary.vue";
import CartLoginForm from "./cardLayoutWidgets/CartLoginForm.vue";
import CartVerification from "./cardLayoutWidgets/CartVerification.vue";
import AddCard from "./cardLayoutWidgets/AddCard.vue";
import ApiService from "@/service/apiService";
import getUserInfo from "@/utils/getUserInfo";
import LoaderVue from "@/components/Loader.vue";
import Cookies from "js-cookie";
import {createToaster} from "@meforma/vue-toaster";
const toaster = createToaster({
  position: 'top-right'
});

export default {
  components: {
    LoaderVue,
    CartOffer, PaymentSummary, CartLoginForm, CartVerification, AddCard
  },
  data() {
    return {
      lang: window?.core?.lang,
      actionType: null,
      loggedIn: false,
      phone: '',
      baskets: [],
      basketLoading: false,
      checkoutLoading: false,
      userInfo: null,
      removeBasketModal: false,
      removeBasketLoading: false,
      removeBasketId: null,
      deliveryStatus: null,
      location: {
        address: '',
        city: ''
      },
      basketTotal: null,
      deliveryPrice: null,
      discount: null
    }
  },

  watch: {
    isCartOpen(newValue, oldValue) {
      if (newValue !== oldValue && newValue === true) {
        this.getBaskets();
      }
    }
  },
  mounted() {
    this.getBaskets();
    const userInfo = getUserInfo();
    if (userInfo) {
      this.userInfo = userInfo;
      this.loggedIn = true;
      this.actionType = 4;
    } else {
      this.actionType = 1;
    }
    const currentLocation = Cookies.get('current_location');
    if(currentLocation){
      this.location = JSON.parse(currentLocation);
    }
    let delivery = Cookies.get('delivery_status');
    if(delivery){
      this.deliveryStatus = JSON.parse(delivery);
    }
  },
  methods: {
    async getBaskets() {
      const userInfo = getUserInfo();
      if (userInfo) {
        try {
          this.basketLoading = true;
          const url = `/payment/get/basket`;
          const response = await ApiService.post(url, {customer_id: userInfo.client.id});
          this.baskets = [];
          let deliveryPrice = 0;
          response.data.data.forEach(each => {
            deliveryPrice += each.delivery_price;
            each.order_details.forEach(basket => {
              basket.decreaseLoading = false;
              basket.increaseLoading = false;
              basket.basket_id = each.id;
              basket.total_price = basket.price * basket.quantity;
              basket.ids = [];
              basket.duplicate_items = [];
              this.baskets.push(basket);
            })
          })
          this.calculateBasketTotal();
          this.deliveryPrice = deliveryPrice.toFixed(2);
          if(this.baskets.length == 0){
            const basketCount = document.getElementById('basketCount');
            basketCount.textContent = 0;
            Cookies.remove('baskets');
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          this.basketLoading = false;
        }
      }
    },

    calculateBasketTotal(){
      let basketTotal = 0;
      this.baskets.forEach(each => {
        basketTotal += each.price * each.quantity;
      })
      this.basketTotal = basketTotal.toFixed(2);
    },

    handleDiscount(data) {
      this.discount = data;
    },

    handleActionType(e, type) {
      e.stopPropagation();
      this.actionType = type;
    },

    handleLogin(event) {
      this.phone = event.phone;
      this.actionType = 3;
    },

    handleVerify() {
      this.actionType = 4;
    },

    async createOrder({delivery, basket_id, location_id}){
      if(this.userInfo){
        try {
          const data ={
            basket_id,
            customer_id: this.userInfo.client.id,
            payment_type: 2,
            test_mode: 1,
            payment_method: 1,
            delivery,
            location_id,
            checkout_id: null
          }
          const url = "/payment/make/order";
          const response = await ApiService.post(url, data);
          if(response.data.status === 200){
            return response.data.data;
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        }finally {
          this.checkoutLoading = false;
        }
      }
    },

    async makeOrder(){
      if(this.userInfo){
        try {
          this.checkoutLoading = true;

          let delivery = Cookies.get('delivery_status');
          if(delivery){
            delivery = JSON.parse(delivery);
          }
          let location_id = Cookies.get('location_id');
          if(delivery == 1){
            if(location_id){
              location_id = JSON.parse(location_id);
            }else {
              toaster.error(this.lang == 'en' ? 'Please select an address.' : 'الرجاء تحديد عنوان.');
              return ;
            }
          }
          const pendingOrders = this.baskets.map(each => {
            return this.createOrder({delivery, location_id, basket_id: each.basket_id});
          })
          const orders = await Promise.all(pendingOrders);
          if(orders.length > 0){
            this.baskets = [];
            const basketCount = document.getElementById('basketCount');
            basketCount.textContent = 0;
            Cookies.remove('baskets');
            toaster.info(this.lang == 'en' ? 'Order has been created successfully.' : 'تم إنشاء الطلب بنجاح.');
            this.$emit('handleOrderComplete', true);
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        }finally {
          this.checkoutLoading = false;
        }
      }
    },

    async increaseBasket(e, data) {
      e.stopPropagation();
      try {
        data.increaseLoading = true;
        const url = '/payment/inc/order'
        const response = await ApiService.post(url, {id: data.id});
        if (response.success) {
          data.quantity++;
          data.total_price = data.quantity * data.price;
          toaster.info(this.lang == 'en' ? 'Basket item has been increased successfully.' : 'تمت زيادة عنصر السلة بنجاح.');
          this.calculateBasketTotal();
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        data.increaseLoading = false;
      }
    },

    async decreaseBasket(e, data) {
      e.stopPropagation();
      if(data.quantity == 1){
        this.removeBasketModal = true;
        this.removeBasketId = data.id;
        return;
      }
      try {
        data.decreaseLoading = true;
        const url = '/payment/dec/order'
        const response = await ApiService.post(url, {id: data.id});
        if (response.success) {
          data.quantity--;
          data.total_price = data.price * data.quantity;
          toaster.info(this.lang == 'en' ? 'Basket item has been decreased successfully.' : 'تم تخفيض عنصر السلة بنجاح.');
          this.calculateBasketTotal();
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        data.decreaseLoading = false;
      }
    },

    async removeBasketItem(e) {
      e.stopPropagation();
      try {
        this.removeBasketLoading = true;
        const url = '/payment/remove/basket/item'
        const response = await ApiService.post(url, {id: this.removeBasketId});
        if (response.success) {
          toaster.info(this.lang == 'en' ? 'Basket item has been removed successfully.' : 'تمت إزالة عنصر السلة بنجاح.');
          this.removeBasketModal = false;
          this.baskets = this.baskets.filter(each => each.id != this.removeBasketId);
          this.calculateBasketTotal();
          const basketCount = document.getElementById('basketCount');
          if(this.baskets.length == 0){
            basketCount.textContent = 0;
            Cookies.remove('baskets');
          }else {
            basketCount.textContent = Number(basketCount.textContent) - 1;
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.removeBasketLoading = false;
      }
    },

    closeModal() {
      this.removeBasketModal = false;
    },

    handleOrderComplete(e) {
      e.stopPropagation();
      this.makeOrder();
    },
  }
}

</script>